//
//
//
//
//

export default {
  props: {
    barData: {
      type: Array, default: () => []
    },
    num: {
      type: Number, default: 0
    },
    type: {
      type: Number,
      default: 0
    },
    val: {
      type: String,
      default: 'data'
    }
  },
  data () {
    return {
      xData: [],
      data: [],
      data1: [],
      lineCharts: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.lineCharts?.resize()
    },
    barData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.lineCharts?.clear() // 清空当前实例
    this.lineCharts?.dispose() // 销毁图表
    this.lineCharts = null
  },
  methods: {
    getData () {
      this.xData = []
      this.data = []
      this.barData?.forEach((item) => {
        this.xData.push(item.date)
        this.data.push({
          name: item.date,
          value: item.numOfAccount
        })
        this.data1.push({
          name: item.date,
          value: item.numOfAccountWithHold
        })
      })
      this.getLineCharts()
    },
    getLineCharts () {
      if (!this.lineCharts) this.lineCharts = this.$echarts.init(document.getElementsByClassName('blowoutData-line-charts-' + this.num)[0])
      const option = {
        // grid: {
        //   left: '0%',
        //   right: '3%',
        //   bottom: '0%',
        //   containLabel: true
        // },

        grid: { // 让图表占满容器
          left: '5px',
          right: '6%',
          bottom: '20%',
          top: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          axisPointer: {
            type: 'none'
          },
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item">${params[0].name}</div>
            <div class="item"><span class="circle-1"></span> ${params[0].value}</div>
            <div class="item"><span class="circle-2"></span> ${params[1].value}</div>
            </div>`
          }

        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(41, 41, 41, 1)'
            }
          },
          axisLabel: {
            formatter: (value) => {
              return value
            },
            textStyle: {
              color: 'rgba(61, 61, 61, 1)'
            }
          },
          axisTick: {
            show: false
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: 'rgba(163, 163, 163, 1)'
            }
          },
          axisLabel: {
            color: 'rgba(204, 204, 204, 1)'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        },
        legend: {
          type: 'scroll',
          data: [this.$t('28688'), this.$t('28689')],
          bottom: '0',
          selectedMode: false,
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 2,
          itemGap: 20,
          textStyle: {
            color: '#3D3D3D',
            fontSize: 12,
            align: 'middle'
          }
        },
        series: [
          {
            symbol: 'circle', // 设定为实心点
            symbolSize: 8,
            data: this.data,
            type: 'line',
            name: this.$t('28688'),
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(59, 118, 246, 0.1)'
              }, {
                offset: 1,
                color: 'rgba(59, 118, 246, 0)'
              }])
            },

            showSymbol: false,

            lineStyle: {
              color: 'rgba(59, 118, 246, 1)',
              join: 'miter'
            },
            smooth: true
          },
          {
            symbol: 'circle', // 设定为实心点
            symbolSize: 8,
            data: this.data1,
            type: 'line',
            name: this.$t('28689'),
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(237, 163, 62, 0.1)'
              }, {
                offset: 1,
                color: 'rgba(237, 163, 62, 0)'
              }])
            },
            itemStyle: {
              color: 'rgba(237, 163, 62, 1)'
            },
            showSymbol: false,

            lineStyle: {
              color: 'rgba(237, 163, 62, 1)',
              join: 'miter'
            },
            smooth: true
          }
        ]
      }
      this.lineCharts.clear()
      this.lineCharts.setOption(option, true)
    }
  }
}
